// extracted by mini-css-extract-plugin
module.exports = {"text":"AddGoal_text__18a4N","paragraph1":"AddGoal_paragraph1__TMCpB","paragraph2":"AddGoal_paragraph2__15Oum","button":"AddGoal_button__D_i8M"};